import React from 'react';
import { Brain } from 'lucide-react';

export function TypingIndicator() {
  return (
    <div className="flex gap-3 items-start">
      <div className="flex-shrink-0 w-8 h-8 sm:w-12 sm:h-12 rounded-full bg-gray-100 flex items-center justify-center">
        <Brain size={16} className="text-gray-600 sm:hidden" strokeWidth={2.5} />
        <Brain size={24} className="text-gray-600 hidden sm:block" strokeWidth={2.5} />
      </div>
      <div className="flex-1 bg-white rounded-lg p-4">
        <div className="flex gap-1">
          <span
            className="w-2 h-2 bg-gray-400 rounded-full animate-bounce"
            style={{ animationDelay: '0ms' }}
          />
          <span
            className="w-2 h-2 bg-gray-400 rounded-full animate-bounce"
            style={{ animationDelay: '150ms' }}
          />
          <span
            className="w-2 h-2 bg-gray-400 rounded-full animate-bounce"
            style={{ animationDelay: '300ms' }}
          />
        </div>
      </div>
    </div>
  );
}
